module.exports = __webpack_public_path__ + "static/media/GiantLanternINTST01A0014_design_clean_v002.fed184d5.webp";